import { useMemo } from 'react';
import { useMercatorMetropolitanId } from 'state/dashboard';
import { REGION_DEFAULT_COORDINATES } from 'utils/constants/location';

export const useCurrentRegion = () => {
  const [currentRegion, setCurrentRegion] = useMercatorMetropolitanId();

  const currentRegionCenter = useMemo(() => {
    if (!currentRegion) {
      return REGION_DEFAULT_COORDINATES['us-austin'];
    }

    return REGION_DEFAULT_COORDINATES[currentRegion];
  }, [currentRegion]);

  return {
    currentRegion,
    setCurrentRegion,
    currentRegionCenter,
  };
};
